// AdminContent/adminupgrade.js
import React, { useState } from 'react';
import { Button, Alert, Card } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL;

const AdminUpgrade = () => {
    const [status, setStatus] = useState('');
    const [error, setError] = useState('');


    return (
        <div className="p-4">
            <h2 className="mb-4">Development Tools</h2>
            <Card className="mb-4">
                <Card.Body>
                    <Card.Title>Superadmin Access</Card.Title>
                    <Card.Text>
                        This is a development tool to grant superadmin access to your account.
                        Use this only in test environments.
                    </Card.Text>
                   
                    {status && <Alert variant="success">{status}</Alert>}
                    {error && <Alert variant="danger">{error}</Alert>}
                </Card.Body>
            </Card>
        </div>
    );
};

export default AdminUpgrade;

